import { CloseThinIcon } from "@starrez/starryui";
import * as React from "react";
import { IRemoveButtonProps } from ".";
import { Button } from "./RemoveButton.styles";

export const RemoveButton: React.FunctionComponent<IRemoveButtonProps> =
    ({ AriaLabel, Disabled, OnClick }: IRemoveButtonProps) => {
        return (
            <Button
                type="button"
                aria-label={AriaLabel}
                disabled={Disabled}
                onClick={!Disabled ? OnClick : undefined}
            >
                <CloseThinIcon Height="15px" Width="15px" />
            </Button>
        );
    };
